(function () {
	'use strict';

	var heroButton = document.querySelector('.hero .btn-primary'),
		bftButton = document.querySelector('.bft .btn-primary'),
		htmlClasses = document.documentElement.classList.value,
		browserName = avastGlobals.detect.browser.name;

	// Switch to Firefox / Mac / iOS tab content if those OS are detected
	// note: setTimeout is set because sometimes Tab content was not visible
	if (browserName === "Firefox") {
		setTimeout(function() {
			document.querySelector(".setup-tab--firefox").click();
		}, 300);
	}
	/*
	-----------------------------
		Full version of Tabs
		- uncomment this once we have ".editorconfig" file for Mac and iOS tab
		- remove code above
		- enable Mac and iOS tab in TXT: https://web-cms.ff.int.avast.com/all/text/edit/67d644689b04145ae0abc585f55d1338
		- original ticket: https://butr.avast.com/browse/GLOWEB-5965
		- contact person who should deliver the ".editorconfig" file: Michal Polačko
	-----------------------------

		if (browserName === "Firefox") {
			setTimeout(function() {
				document.querySelector(".setup-tab--firefox").click();
			}, 300);
		} else if (/js-ios/.test(htmlClasses) || /js-mac/.test(htmlClasses) && navigator.maxTouchPoints > 0) {
			setTimeout(function() {
				document.querySelector(".setup-tab--ios").click();
			}, 300);
		} else if (/js-mac/.test(htmlClasses)) {
			setTimeout(function() {
				document.querySelector(".setup-tab--mac").click();
			}, 300);
		}
	*/

	// DataLayer push on CTA button click for tracking purposes
	heroButton.addEventListener('click', function () {
		if (typeof window.dataLayer !== 'undefined') {
			dataLayer.push({
				"event": "av.genericEvent",
				"eventCategory": "CTA > Other",
				"eventAction": "Turn on dns protection - top",
				"eventLabel": avastGlobals.web.fileName
			});
		}
	});

	bftButton.addEventListener('click', function () {
		if (typeof window.dataLayer !== 'undefined') {
			dataLayer.push({
				"event": "av.genericEvent",
				"eventCategory": "CTA > Other",
				"eventAction": "Turn on dns protection - bottom",
				"eventLabel": avastGlobals.web.fileName
			});
		}
	});

})();
